import { useFlagsWithOverrides } from './useFlagsWithOverrides';

const flagName = 'billing-tab-enabled';

export function useBillingTabEnabled() {
  const flags = useFlagsWithOverrides([flagName]);
  return flags[flagName].enabled;
}
